<template>
  <div v-if="element == 'body'">
    <div
      v-if="!(userData && userData.id) && country.code == 'pe'"
      class="c-card-alert c-card-alert--error p-3 text-center mb-4">
      <span>
        Para realizar esta compra por este medio de pago necesitas primero
        <router-link
          :to="`/ingresar?back_url=${backUrl}`"
          class="w-bold"
          style="color: #e10000;"
        >
          INGRESAR
        </router-link>
        a tu cuenta o
        <router-link
          :to="`/registrarse?back_url=${backUrl}`"
          class="w-bold"
          style="color: #e10000;"
        >
          CREAR UNA NUEVA CUENTA.
        </router-link>
      </span>
    </div>
    <template v-if="(userData && userData.id) && country.code == 'pe'">
      <h3 class="fs-18 darks w-bold mb-3">1. Ingresa tus datos para generar tu código de pago</h3>
      <div class="row mb-2">
        <div class="col col-12 col-md-6 mb-4">
          <p class="c-form__label mb-1">Nombre completo</p>
          <input
            v-model="user.fullName.value"
            @keypress="isRightField($event, 'letter')"
            @keydown.enter.tab="user.fullName.tested = true"
            type="text"
            class="c-form__input w-100"
            placeholder="ej. Raul Sanchez Rojas"/>
          <span v-if="isWrongField(user.fullName)" class="c-form__error">
            {{
              (!user.fullName.value.length)
                ? 'Nombre incorrecto'
                : 'Ingresa tus nombres completos'
            }}
          </span>
        </div>
        <div class="col col-12 col-md-6 mb-4">
          <p class="c-form__label mb-1">Correo electrónico</p>
          <input
            v-model.trim="user.email.value"
            @keydown.enter.tab="user.email.tested = true"
            :disabled="userData"
            type="text"
            class="c-form__input w-100"
            placeholder="ej. raul@ejemplo.com"/>
          <span v-if="isWrongField(user.email)" class="c-form__error">Correo incorrecto</span>
        </div>
        <div v-if="!userData" class="col col-12 col-12 mb-3 mb-md-4">
          <p class="c-form__label mb-1">Número de celular</p>
          <VuePhoneNumberInput
            v-model="user.phone.value"
            @update="updatePhoneDetails"
            @phone-number-blur="user.phone.tested = true"
            class="c-form__phone"
            :no-example="true"
            :fetch-country="true"
            :translations="translations"/>
          <span v-if="isWrongField(user.phone)" class="c-form__error">Número incorrecto</span>
        </div>
      </div>
      <h3 class="fs-18 darks w-bold mb-3">2. Elige una opción</h3>

      <b-tabs class="c-tabs c-tabs--checkout">
        <b-tab active>
          <template #title>
            <p class="mb-0 d-flex flex-column align-items-center justify-content-center">
              <img src="../../../assets/images/icons/checkout/bank.svg" alt="Efectivo" />
              <span class="ml-2 mt-2 mt-md-0 text-center">Transferencia bancaria</span>
            </p>
          </template>
          <section class="p-1 p-md-2">
            <h4 class="w-bold fs-16 darks mb-3">¿Cómo funciona?</h4>
            <ol class="ul-reset fs-14">
              <li
                v-for="(item, iindex) of methods.bank"
                :key="item.id"
                class="d-flex"
                :class="{'mb-2' : iindex < (methods.bank.length - 1)}">
                <p class="mb-0">
                  <span class="w-bold mr-2">{{iindex + 1}}.</span>
                </p>
                <p class="mb-0" v-html="item"></p>
              </li>
            </ol>
          </section>
        </b-tab>
        <b-tab active>
          <template #title>
            <p class="mb-0 d-flex flex-column align-items-center justify-content-center">
              <img
                class="c-icon of--contain"
                src="../../../assets/images/icons/checkout/cash.svg"
                alt="Efectivo" />
              <span class="ml-2 mt-2 mt-md-0 text-center">Depósito en efectivo</span>
            </p>
          </template>
          <section class="p-1 p-md-2">
            <h4 class="w-bold fs-16 darks mb-3">
              ¿Cómo hacer un deposito en efectivo a través de Pago Efectivo?
            </h4>
            <ol class="ul-reset fs-14">
              <li
                v-for="(item, iindex) of methods.deposit"
                :key="item.id"
                class="d-flex"
                :class="{'mb-2' : iindex < (methods.bank.length - 1)}">
                <p class="mb-0">
                  <span class="w-bold mr-2">{{iindex + 1}}.</span>
                </p>
                <p class="mb-0" v-html="item"></p>
              </li>
            </ol>
          </section>
        </b-tab>
      </b-tabs>
    </template>
    <template v-else>
      <p class="mb-3">
        Por el momento solo aceptamos
        <span class="w-sbold">PAGOS EN EFECTIVO DESDE PERÚ</span>,
        si eres de este
        país nuestro equipo se comunicara contigo para brindarte las instrucciones de pago.
      </p>
      <p class="mb-0">
        Para el resto de países disponemos de las opciones de pago
        con tarjeta (crédito o débito) y paypal. 💚
      </p>
    </template>
  </div>
  <div v-else>
    <template v-if="country.code == 'pe'">
      <button
        :disabled="isLoading"
        @click="sendCashInfo"
        target="_blank"
        class="c-button c-button--primary w-100 d-flex
          align-items-center justify-content-center mt-2"
        :class="{loading : isLoading}">
        {{ (isLoading) ? 'Generando...' : 'Generar código' }}
        <img
          class="c-button__spinner"
          src="../../../assets/images/animations/spinner-white.png"
          alt="loading" />
      </button>
    </template>
    <template v-if="false">
      <a
        :href="whatsappLink"
        target="_blank"
        class="c-button c-button--primary w-100 d-flex
          align-items-center justify-content-center mt-2">
        <i class="icon-whatsapp me-2 d-flex align-items-center white"></i>
        Pagar por whatsapp
      </a>
      <a
        :href="messengerLink"
        target="_blank"
        class="c-button w-100 d-flex align-items-center
          justify-content-center mt-2 c-button--messenger">
        <i class="icon-messenger me-2 d-flex align-items-center white"></i>
        Pagar por messenger
      </a>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import VuePhoneNumberInput from 'vue-phone-number-input';

import { mapState } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      methods: {
        bank: [
          'Presiona el boton para generar un código de Pago referente a la compra que sera <b>valido por 3 días.</b>',
          '<b>Realiza una transferencia bancaria</b> a través de la web de tu banco o banca movil.',
          'Entra a la opción Pago de Servicios > Empresas diversas y selecciona <b>“PAGO EFECTIVO”</b> e ingresa el <b>código CIP</b> que te enviaremos por correo.',
          'Cuando la transacción sea confirmada <b>recibirás un recibo compra y un email con los datos de acceso al producto</b> (verifica también la carpeta de SPAM).',
        ],
        deposit: [
          'Presiona el boton para generar un código de Pago referente a la compra que sera <b>valido por 3 días.</b>',
          '<b>Serás direccionado a una página con el código</b> y los <b>datos generados</b> para realizar el pago. Esos datos también llegarán <b>a tu correo.</b>',
          'Con el código generado puedes realizar el <b>pago en efectivo</b> en mas de los <b>40 mil puntos</b> de recaudo de <b>PagoEfectivo</b> del país. ',
          'Cuando la transacción sea confirmada Recibirás un recibo de la compra y un email con los datos de acceso al producto (verifica también la carpeta de SPAM).',
        ],
      },
      translations: {
        phoneNumberLabel: 'ej. 944444444',
      },
    }
  },
  components: {
    VuePhoneNumberInput,
  },
  props: [
    'arcux',
    'element',
    'step',
    'user',
    'coupon',
    'price',
    'product',
    'productPlan',
    'isRightField',
    'isWrongField',
    'backUrl',
  ],
  computed: {
    ...mapState({
      userData: (state) => state.user.userData,
      country: (state) => state.checkout.country,
    }),

    whatsappLink() {
      let url = `https://api.whatsapp.com/send?phone=${this.arcux.project.phone}&text=Hola,%20me%20gustaría%20pagar%20por${(this.product.type == 'course' ? '%20el%20curso%20' : (this.product.type == 'pack' ? '%20la%20' : '%20la%20suscripción%20'))}${this.product.data.title}%20en%20efectivo%20por%20favor. (${ this.price })`;

      return this.coupon.code.isValid ? url + ` (cupón ${this.coupon.code.value})` : url;
    },
    messengerLink() {
      return `https://m.me/${this.arcux.project.facebook_name}/`;
    },
  },
  methods: {
    updatePhoneDetails: function(e) {
      let tempUser = this.user;

      tempUser.phone.isValid = (e.isValid) ? true : false;

      this.$emit('update:user', tempUser);
    },
    sendCashInfo: function() {
      this.user.try = true;

      const valid = this.user.fullName.isValid && this.user.email.isValid && this.user.terms;

      if (valid) {
        this.isLoading = true;

        const fullName  = this.user.fullName.value.trim().replace(/\s+/g, ' ');

        const params = {
          product_type: this.product.type == 'course' ? 'course' : 'subscription',
          plan: this.productPlan,
          selected_country: (this.country.code == 'world' || this.country.code == 'us') ? 'us' : 'pe',
          country_code: this.country.codeOrigin,
        };

        if (this.coupon.code.isValid) {
          params.coupon = this.coupon.code.value;
        }

        params.first_name = fullName.substr(0, fullName.indexOf(' '));
        params.last_name  = fullName.substr(fullName.indexOf(' ') + 1);
        params.email      = this.user.email.value;

        params.payment_method   = 'cash';
        params.payment_gateway  = 'pagoefectivo';

        if(!(this.userData && this.userData.id)) {
          params.phone    = this.user.phone.value;
          params.user_tmp = window.sessionStorage.getItem('user_temp')
        }

        fetch(`${this.arcux.site}/api/v1/checkout/products/${this.product.data.id}/cash`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ... (this.userData && this.userData.id) && { Authorization: `Bearer ${window.arcux.token}` },
          },
          body: JSON.stringify(params),
        })
        .then(res => {
          if (res.status == 201 || res.status < 300) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then((response) => {
          window.setTimeout(() => {
            this.$router.push({
              path: `/checkout/order-received/${response.data.order}`,
            });

            this.isLoading = false;
          }, 1000);
        })
        .catch(err => {
          window.setTimeout(() => {
            this.isLoading = false;
          }, 1000);

          throw err;
        })
      }
    },
  },
}
</script>
